import React from "react";

const DeleteConfirmationModal = ({ open, title, message, onConfirm, onCancel }) => {
	if (!open) return null;

	return (
		<div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
			<div
				className="bg-white rounded-lg shadow-lg p-6 w-[520px] max-w-[90%]"
				onClick={(e) => e.stopPropagation()}
			>
				<h3 className="text-2xl font-semibold text-purple-900 mb-2">{title}</h3>
				<p className="text-sm text-gray-600 mb-4">{message}</p>
				<div className="flex justify-end gap-3">
					<button
						onClick={onCancel}
						className="px-4 py-2 rounded border text-gray-700 bg-white hover:bg-gray-50"
					>
						Cancel
					</button>
					<button
						onClick={onConfirm}
						className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600"
					>
						Delete
					</button>
				</div>
			</div>
		</div>
	);
};

export default DeleteConfirmationModal;


